export default __webpack_public_path__ + "static/summer_containers91-2da8925321d7a5c485f6e0e84b88aefb.webp";